import { Component, Input } from '@angular/core';
import { CommIFPortStatus } from '@models/system-status';

@Component({
    selector: 'app-ports-status-indicator',
    templateUrl: './ports-status-indicator.component.html',
    styleUrls: ['./ports-status-indicator.component.scss'],
    standalone: false,
})
export class PortsStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() port: CommIFPortStatus;
    @Input() commIFNumber: number;
}
